var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",class:_vm.classes,attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.UpdateValue()},"blur":_vm.blurFunction}})
}
var staticRenderFns = []

export { render, staticRenderFns }